/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { useCallback, useMemo } from "react";
import { ROUTES } from "../constants/constants";
import { useConfig } from "../lib/react-query/useConfig";
import { useProductsCategories } from "../lib/react-query/useProducts";
import { useDispatch } from "react-redux";
import { setSelectedCategory } from "../store/slices/productsSlice";
import { navFeatureRegistry } from "../navigation/navFeatureRegistry";
import usePluginUtils from "./usePluginUtils";

export const useNavigationItems = (customFeatures) => {
  const { data: config } = useConfig();
  const { isPluginEnabled } = usePluginUtils();
  const { data: categoriesData } = useProductsCategories({
    enabled: Boolean(isPluginEnabled("product") && config?.product_use_categories),
  });
  const dispatch = useDispatch();
  const { hasProductsForSale, hasGiftCards, hasMemberships, hasPackages } = customFeatures;

  const resetCategory = useCallback(() => {
    dispatch(setSelectedCategory(null));
  }, [dispatch]);

  return useMemo(() => {
    const navContext = {
      config,
      categoriesData,
      resetCategory,
      hasProductsForSale,
      hasGiftCards,
      hasMemberships,
      hasPackages,
    };

    const items = [{ label: "Home", route: ROUTES.HOME }];

    for (const feature of navFeatureRegistry) {
      if (feature.isEnabled(navContext)) {
        items.push(feature.buildNavItem(navContext));
      }
    }

    return items;
  }, [config, categoriesData, resetCategory, hasProductsForSale, hasGiftCards, hasMemberships, hasPackages]);
};
